<template>
  <v-dialog v-model="showDialog" max-width="650" persistent>
    <v-card>
      <ModalHeader
        title="Edit Equipment"
        icon="mdi-clipboard-list"
        @close="showDialog = false"
      />
      <v-card-text class="pa-4">
        <v-text-field
          outlined
          dense
          v-model="equipment.name"
          label="Equipment Name"
          prepend-icon="mdi-toolbox"
        ></v-text-field>
        <v-select
          outlined
          dense
          v-model="equipment.type"
          :items="typeOptions"
          label="Type"
          prepend-icon="mdi-shape"
        ></v-select>
        <v-text-field
          outlined
          dense
          v-model="equipment.category"
          label="Category"
          prepend-icon="mdi-tag"
          hint="e.g. Security, Electrical, Cleaning"
          persistent-hint
        ></v-text-field>
        <v-textarea
          outlined
          dense
          v-model="equipment.designated_location"
          label="Designated Location"
          prepend-icon="mdi-map-marker"
          rows="2"
          auto-grow
        ></v-textarea>
        <v-text-field
          outlined
          dense
          v-model.number="equipment.sort_order"
          label="Sort Order"
          type="number"
          min="0"
          prepend-icon="mdi-sort"
        ></v-text-field>
        <v-switch
          v-model="equipment.is_active"
          label="Active"
          color="green"
        ></v-switch>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="showDialog = false">Cancel</v-btn>
        <v-btn color="primary" :loading="loading" @click="submit">
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["show", "equipment"],
  computed: {
    showDialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  data() {
    return {
      loading: false,
      typeOptions: [
        { text: "Facility Equipment", value: "equipment" },
        { text: "Tool", value: "tool" },
      ],
    };
  },
  methods: {
    ...mapActions({
      edit_equipment: "facilities/edit_equipment",
    }),
    async submit() {
      if (!this.equipment.name) return;
      this.loading = true;
      try {
        await this.edit_equipment(this.equipment);
        this.showDialog = false;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
  },
};
</script>
